export default function Header() {
    return (
        <header className="fixed top-0 left-0 right-0 z-20 h-[var(--header-height)] bg-sidebar
                 flex items-center pl-5 pt-2">
            <span className="text-lg font-bold logo-font">Edit Engine</span>
        </header>
    )
}